export default {
  name: "Preparer",
  pageInfo: {
    text: `Complete this section if the preparer of this application is a person other than the one identified in either Section B (employer point of contact) or section C (attorney or agent) of this application.`,
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          code: "J.1",
          machine_name: "prepLastName",
          widget: "text",
          label: "Last (family) Name §",
          maxLength: 35,
          tooltip: `Enter the full legal (family) last name of the preparer’s point of contact.`,
          validate: [
            {
              tripleFieldComparison: "",
              extraData: {
                fields: [
                  {
                    this: "=",
                    fieldVal: "prepLastName",
                    two: "empPocLastName",
                    three: "attyAgLastName",
                  },
                ],
              },
              message: "Preparer is the same as Employer POC or Agent/Attorney",
              needsFieldValues: true,
            },
            {
              minLength: 2,
              message: "Last Name must contain at least 2 characters",
            },
          ],
        },
        {
          code: "J.2",
          machine_name: "prepfirstName",
          widget: "text",
          label: "First (given) Name §",
          validate: [
            {
              tripleFieldComparison: "",
              extraData: {
                fields: [
                  {
                    this: "=",
                    fieldVal: "prepfirstName",
                    two: "empPocFirstName",
                    three: "attyAgFirstName",
                  },
                ],
              },
              message: "Preparer is the same as Employer POC or Agent/Attorney",
              needsFieldValues: true,
            },
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip: `Enter the full (given) first name of the preparer’s point of contact.`,
        },
        {
          code: "J.3",
          machine_name: "prepMiddleName",
          widget: "text",
          label: "Middle Name(s) §",
          validate: ["noNAs"],
          maxLength: 35,
          tooltip: `Enter the middle name of the preparer’s point of contact.`,
        },
        {
          code: "J.4",
          machine_name: "prepLawFirmFEIN",
          widget: "text",
          label: "Law Firm/Business FEIN §",
          validate: [
            "fein",
            { minLength: 10, message: "This is not a valid FEIN" },
          ],
          parse: "fein",
          maxLength: 10,
          tooltip: `Enter the nine-digit FEIN as assigned by the IRS.  Do not enter a social security number.`,
        },
        {
          code: "J.5",
          machine_name: "prepFirmBusinessName",
          widget: "text",
          label: "Law Firm/Business Name §",
          validate: [
            "noNAs",
            {
              minLength: 5,
              message: "Legal Business Name must contain at least 5 characters",
            },
          ],
          maxLength: 120,
          tooltip: `Enter the full legal name of the business, person, association, firm, corporation, i.e. the preparer filing this application.  
          The preparer’s full legal name is the exact name of the individual, corporation, LLC,
          partnership, or other organization that is reported to the IRS.`,
        },
        {
          code: "J.6",
          machine_name: "prepEmail",
          widget: "text",
          label: "Law Firm/Business Email Address §",
          validate: [
            {
              email: {
                extraData: {
                  allowNAs: false,
                },
              },
            },
          ],
          maxLength: 100,
          tooltip: `Enter the full business email address of the preparer’s point of contact in the format <u>name@emailaddress.top-level domain</u>.`,
        },
      ],
    },
  ],
};
